import type {RouteLocationRaw} from 'vue-router';
import {InvitationStep, type UserInvitationStep} from '~~/api/models';
import type {InvitationStatus} from '~/types/invitation';

type InvitationRouteStatus = InvitationStatus & Partial<Pick<UserInvitationStep, 'token'>>;

export function getInvitationStepRoute(
  invitation: InvitationRouteStatus,
  currentStep?: InvitationStep,
  currentToken?: string,
  exitRoute: RouteLocationRaw = '/'
): RouteLocationRaw | null {
  if (invitation.step === currentStep) return null;
  if (
    currentStep === InvitationStep.Details &&
    (
      invitation.step === InvitationStep.Sent ||
      invitation.step === InvitationStep.Details ||
      invitation.step === InvitationStep.Password
    )
  ) {
    return null;
  }

  const token = invitation.token ?? currentToken;

  switch (invitation.step) {
    case InvitationStep.Unsent:
      return {name: 'invitation-expired'};
    case InvitationStep.Completed:
      return exitRoute;
    case InvitationStep.Sent:
    case InvitationStep.Details:
      return token ? {name: 'invitation-invitation', params: {invitation: token}} : null;
    case InvitationStep.Password:
      return token ? {name: 'invitation-invitation-password', params: {invitation: token}} : null;
    case InvitationStep.TwoFactor:
      return token ? {name: 'invitation-invitation-two-factor', params: {invitation: token}} : null;
    default:
      return {name: 'invitation-expired'};
  }
}

export function getActiveInvitationRoute(
  invitation: InvitationRouteStatus,
  exitRoute: RouteLocationRaw = '/'
): RouteLocationRaw | null {
  return getInvitationStepRoute(invitation, undefined, undefined, exitRoute);
}

export function getInvitationExitRoute(isAuthenticated: boolean): RouteLocationRaw {
  return isAuthenticated ? '/documents/inbox' : '/';
}

export function isInvalidInvitationStep(step?: InvitationStep): boolean {
  return step === undefined || step === InvitationStep.Unsent;
}